export interface InfluencerData {
  name: string;
  handle: string;
  followers: string;
  postUrl: string;
  coverUrl: string;
  profileImageUrl: string;
  likes: number;
  quote: string;
}

export const influencersData: InfluencerData[] = [
  {
    name: "良辰筆記 Blessed Day Notes",
    handle: "blesseddaynotes",
    followers: "13.9 萬粉絲",
    postUrl: "https://www.instagram.com/reel/DHnuKhTyNZQ/",
    coverUrl: "https://cdn-site.clarymind.com/product-page-app/influencer-covers/blesseddaynotes-cover.jpg",
    profileImageUrl: "https://cdn-site.clarymind.com/product-page-app/influencer-profiles/blesseddaynotes.jpg",
    likes: 13813,
    quote: "分享我最近戒手機的好方法！幫助我擺脫焦慮，增加生產力💪🏻 Clarymind 可以將社群APP上鎖，還有可愛角色提醒自己不要再滑社群了！非常適合手機上癮、意志力薄弱、有拖延症的朋友",
  },
  {
    name: "三分鐘 | 行銷在學中 Lynn Lin",
    handle: "only3minute",
    followers: "9.92 萬粉絲",
    postUrl: "https://www.instagram.com/reel/DMXsCwLTJ1y/",
    coverUrl: "https://cdn-site.clarymind.com/product-page-app/influencer-covers/only3minute-cover.jpg",
    profileImageUrl: "https://cdn-site.clarymind.com/product-page-app/influencer-profiles/only3minute.jpg",
    likes: 5180,
    quote: "居然已經連續3個月每天滑 Threads 不超過30分鐘‼️這雖然是篇合作貼文，但我本人使用 Clarymind 超過 3 個月了，而這個期間，我從每天滑 6 小時的脆，減少到每次10分鐘，一天只能滑3次，有好幾天甚至開也沒開，把時間用在更重要的事情上。",
  },
  {
    name: "周周♡｜閱讀心得｜自我成長｜小資理財",
    handle: "read.chouuu",
    followers: "3.34 萬粉絲",
    postUrl: "https://www.instagram.com/p/DHa07VntC_4/",
    coverUrl: "https://cdn-site.clarymind.com/product-page-app/influencer-covers/read.chouuu-cover.jpg",
    profileImageUrl: "https://cdn-site.clarymind.com/product-page-app/influencer-profiles/read.chouuu.jpg",
    likes: -1,
    quote: "我最喜歡 AI 提醒機制，幫助我意識到「無意識的滑動」以前，我總是無意識地打開社群 App，明明只是想放鬆一下，卻一不小心就刷了半小時，甚至忘記自己原本要做什麼。但 Clarymind的 AI 提醒機制讓我開始覺察這個問題。",
  },
  {
    name: "推書手L｜閱讀書評 | 寫作日常｜自我成長",
    handle: "yourbooker_l",
    followers: "3.3 萬粉絲",
    postUrl: "https://www.instagram.com/p/DIoJvv7TFR9/",
    coverUrl: "https://cdn-site.clarymind.com/product-page-app/influencer-covers/yourbooker_l-cover.jpg",
    profileImageUrl: "https://cdn-site.clarymind.com/product-page-app/influencer-profiles/yourbooker_l.jpg",
    likes: 572,
    quote: "克服手機成癮的最佳手段，是學會有意識地建立我們與科技間的界線。只靠意志力逼自己不去用手機，並不是個長久的方法。Clarymind 也深知這件事，並不是直接強迫我們不能用手機，而是以對話和互動的方式，使我們在想滑手機時，自我覺察社群使用的必要性。",
  },
  {
    name: "巴黎不要笑",
    handle: "paris_rispas",
    followers: "8.7 萬粉絲",
    postUrl: "https://www.instagram.com/reel/DMAcdJzzcxR/",
    coverUrl: "https://cdn-site.clarymind.com/product-page-app/influencer-covers/paris_rispas-cover.jpg",
    profileImageUrl: "https://cdn-site.clarymind.com/product-page-app/influencer-profiles/paris_rispas.jpg",
    likes: 3328,
    quote: "如果你也有社群焦慮，或是無意識滑手機拖延或逃避的問題，推薦你台灣團隊開發的Clarymind！我一直相信，創造自律的環境才是自律最有效的方式 Clarymind 讓我不用負擔克制自己的成本，無痛專注自律",
  },
  {
    name: "Ario 愛芮兒",
    handle: "ario_1015",
    followers: "2.5 萬粉絲",
    postUrl: "https://www.instagram.com/reel/DJEozrgzKq8/",
    coverUrl: "https://cdn-site.clarymind.com/product-page-app/influencer-covers/ario_1015-cover.jpg",
    profileImageUrl: "https://cdn-site.clarymind.com/product-page-app/influencer-profiles/ario_1015.jpg",
    likes: 418,
    quote: "Clarymind 這個好幫手，用最溫柔的方式，讓我花了半年的時間，才終於可以成功大聲說：我戒掉手機成癮、社群焦慮，然後不會再熬夜滑呀滑，捨不得把手機關起來去睡覺。",
  },

];